const data: Record<string, string> = {
    'AUTHENTICATION_POPUP_TITLE': 'You are not logged in',
    'AUTHENTICATION_POPUP_BODY': 'You need to login to perform this action.',

    'LOGIN_HEADER': 'Login to Back Office',
    'LOGIN_SUBTITLE': 'Enter your credentials below to get started',

    'USER_USERNAME_LABEL': 'Username',
    'USER_EMAIL_LABEL': 'Email',
    'USER_PASSWORD_LABEL': 'Password',

    'LOGIN_SUBMIT_BUTTON': 'Log In',

    'DATE_RANGE_FROM_LABEL': 'From',
    'DATE_RANGE_TO_LABEL': 'To',
    'DATE_RANGE_NEXT_BUTTON': 'Search dates',

    'USER_TITLE_LABEL': 'Title',
    'USER_FIRST_NAME_LABEL': 'First name',
    'USER_LAST_NAME_LABEL': 'Last name',
    'USER_DAY_OF_BIRTH_LABEL': 'Date',
    'USER_MONTH_OF_BIRTH_LABEL': 'of',
    'USER_YEAR_OF_BIRTH_LABEL': 'birth',
    'USER_COUNTRY_LABEL': 'Country of residence',
    'USER_CURRENCY_LABEL': 'Currency',
    'USER_TITLE_MR_LABEL': 'Mr',
    'USER_TITLE_MRS_LABEL': 'Mrs',
    'USER_TITLE_MS_LABEL': 'Ms',
    'USER_TITLE_MISS_LABEL': 'Miss',

    'ERROR_UNKNOWN': 'Unknown error',
    'ERROR_REQUIRED_FIELD': 'This field is required.',
    'ERROR_CHECKED_FIELD': 'You have to select this field.',
    'ERROR_INCORRECT_EMAIL': 'Incorrect e-mail address.',
    'ERROR_PHONE': 'Phone number can contain only spaces and numbers.',
    'ERROR_PASSWORD': '8-20 characters with only letters, numbers and few special: !"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~',
    'ERROR_INVALID_CITY': 'Only letters, numbers and few special: -\'&',
    'ERROR_INVALID_ADDRESS': 'Only letters, numbers, spaces and few special: !"#$&\'()*+,-./:;<=>?@[\\]^_`{|}~',
    'ERROR_ALPHA_ONLY': 'Only letters are allowed.',
    'ERROR_ALPHA_SPACES_ONLY': 'Only letters, spaces, hyphens and apostrophes are allowed.',
    'ERROR_ALPHA_SPACES_NUMBERS_ONLY': 'Only letters, numbers and spaces are allowed.',
    'ERROR_NUMERIC': 'Only digits are allowed.',
    'ERROR_CARD_NUMBER': 'Incorrect card number.',
    'ERROR_CVC': 'Incorrect CVC number.',
    'ERROR_INVALID_POSTCODE': 'Postcode can contain only letters, digits and hyphen (1-10 chars)',
    'ERROR_DECIMAL': 'Incorrect number.',
    'ERROR_FRACTIONAL': 'Incorrect fractional number',
    'ERROR_CONFIRM_EMAIL': 'This e-mail address is not the same.',
    'ERROR_CONFIRM_PASSWORD': 'This password is not the same.',
    'ERROR_MAX_LENGTH': 'This field can have maximum %d characters.',
    'ERROR_MIN_LENGTH': 'This field can have minimum %d characters.',
    'ERROR_INVALID_PRECISION': 'The fractional part can have a maximum of %d digits',
    'ERROR_INVALID_SURNAME': 'Surname starts from letter and contains letters, spaces, hyphens and apostrophes.',
    'ERROR_INVALID_DATE': 'Invalid date.',
    'ERROR_ADULT': 'Too young person.',
    'ERROR_HALF_DECIMAL': 'Value must have decimal part equal to 0.5',
    'ERROR_POSITIVE': 'Value should be positive.',
    'ERROR_INVALID_RANGE': 'Value must be between [{1}-{2}]',
    'ERROR_INCORECT_VALUE': 'Invalid value specified',

    'ERROR_INCORRECT_USERNAME_PASSWORD': 'Incorrect e-mail or password.',
    'ERROR_INVALID': 'This field is invalid.',
    'ERROR_ALREADY_EXISTS': 'This e-mail already exists.',

    'USER_ADDRESS_LINE_1_LABEL': 'Address line 1',
    'USER_ADDRESS_LINE_2_LABEL': 'Address line 2',
    'USER_CITY_LABEL': 'Town or city',
    'USER_CONTACT_NUMBER_LABEL': 'Contact number',
    'USER_CONTACT_NUMBER_PREFIX_LABEL': 'Prefix',
    'USER_POSTCODE_LABEL': 'Postcode',

    'PAYMENT_METHOD_REMOVE_CONFIRMATION_MESSAGE': 'Are you sure you want to remove '
};

export const getTranslationFor = (id: string): string => {
    const phrase = data[id] ?? id;
    return phrase;
};
